const initialState: CardState = {
  isRejected: false,
};

export default function cardReducer(
  state = initialState,
  action: { type: string; isAccepted?: boolean; isRejected?: boolean }
) {
  switch (action.type) {
    case "REJECT_CARD":
      return {
        ...state,
        isAccepted: false,
        isRejected: action.isRejected ?? true,
      };
    default:
      return state;
  }
}
